<script lang="ts">
import { Popover } from 'element-ui';
export default Popover;
</script>
